module.exports = __webpack_public_path__ + "static/fonts/NanumSquareB.81807f5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareB.eot
// module id = YUqa
// module chunks = 1